module.exports = __webpack_public_path__ + "public/Icons/womanIcon.svg?90fb4815";